import { z } from "zod";

export const createSupplierPaymentValidation = z.object({
  amount: z.number({ message: "Amount is required" }),
  payee: z.object({
    connect: z.string(),
  }),
  description: z.string({ message: "Description is required" }).min(1),
});
